import React from "react";
import { useRef, useState } from "react";
import Layout from "../components/Layout";
import { FaReact, FaNodeJs } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  SiBlender,
  SiAdobeillustrator,
  SiAffinity,
  SiMongodb,
  SiJavascript,
  SiFigma,
} from "react-icons/si";
import AOS from "aos";

AOS.init();

function Home() {
  const formRef = useRef();
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const clearMessages = () => {
    setName("");
    setSubject("");
    setEmail("");
    setMessage("");
    clearToast();
  };

  const clearToast = () => {
    toast.info("Form has been cleared!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const errorToast = () =>
    toast.warn("Uh Oh! Did you fill in all the details?", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const successToast = () => {
    toast.success(
      "I will reply you as soon as I am online, Have a wonderful day/night!",
      {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !subject || !email || !message) {
      return errorToast();
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_GMAIL,
        process.env.REACT_APP_TEMPLATE,
        formRef.current,
        process.env.REACT_APP_VIID
      )
      .then(
        (result) => {
          console.log(result.text);
          successToast();
          clearMessages();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <Layout>
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* Intro section */}
        <div className="h-screen bg-theme" data-aos="zoom-out">
          <div className="grid md:grid-cols-1 grid-cols-2 h-screen items-center border-4 md:border-0 mx-10 z-10 bg-theme border-themedk rounded-md ">
            <div className="h-1/2">
              <lottie-player
                src="https://assets3.lottiefiles.com/packages/lf20_ghs9bkkc.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className="font-bold md:px-5">
              <h1 className="text-7xl md:text-4xl text-themedk">
                Greetings, I am <b className="text-compdk">VINO</b>
              </h1>
              <h1 className="text-4xl md:text-xl text-themedk">
                UI/UX Designer, 3D Modeller, Illustrator
              </h1>
            </div>
          </div>
        </div>
        {/* technologies */}

        <div className="mt-20">
          <h1
            className="text-4xl text-blue-800 font-bold text-center my-8"
            data-aos="fade-up"
          >
            Technologies I use
          </h1>
          <div className="grid md:grid-cols-1 grid-cols-4 " data-aos="zoom-in">
            <FaReact
              size={180}
              color="cyan"
              className="w-full text-center mt-20"
            />
            <SiBlender
              size={180}
              color="orange"
              className="w-full text-center mt-20"
            />
            <SiAdobeillustrator
              size={180}
              color="brown"
              className="w-full text-center mt-20"
            />
            <SiAffinity
              size={180}
              color="purple"
              className="w-full text-center mt-20"
            />
            <FaNodeJs
              size={180}
              color="green"
              className="w-full text-center mt-20"
            />

            <SiFigma
              size={180}
              color="purple"
              className="w-full text-center mt-20"
            />
            <SiMongodb
              size={180}
              color="green"
              className="w-full text-center mt-20"
            />
            <SiJavascript
              size={180}
              color="yellow"
              className="w-full text-center mt-20"
            />
          </div>
        </div>

        {/* buff */}
        <div className="my-20">
          <div className="text-center h-52 bg-theme" data-aos="fade-up">
            <h1 className="text-themedk font-bold md:text-xl text-4xl py-10">
              In Love With Graphics Design And Fueled With Creativity
            </h1>
          </div>

          <div
            className="md:mx-5 mx-32 shadow-2xl bg-gray-50 -mt-20 rounded-lg hover:bg-compdk hover:text-themelt"
            data-aos="zoom-out-down"
          >
            <div className="h-96">
              <lottie-player
                src="https://assets10.lottiefiles.com/packages/lf20_m9fz64i8.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <p className="text-xl my-5 font-semibold md:px-5 px-14 py-10">
              I use lots of open source packages for my technologies such as
              Blender and Javascript libraries. I use Javascript for Web
              Development, Affinity Suite for Designing and Illustration. I use
              Figma for UI/UX designs and prototyping.
            </p>
          </div>
        </div>

        {/* stack */}
        <div className="my-20">
          <div className="text-center h-52 bg-theme" data-aos="fade-up">
            <h1 className="text-themedk font-bold md:text-2xl text-4xl py-10">
              Softwares and Stacks that I use
            </h1>
          </div>

          <div
            className="md:mx-5 mx-32 shadow-2xl bg-gray-50 -mt-20 rounded-lg hover:bg-compdk hover:text-themelt"
            data-aos="zoom-out-down"
          >
            <div className="h-96">
              <lottie-player
                src="https://assets9.lottiefiles.com/packages/lf20_aw0n2o.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className="grid md:grid-cols-1 grid-cols-3 p-10">
              <div className="text-left">
                <h1 className="text-xl font-bold ">Softwares</h1>
                <hr />
                <p className="font-semibold mt-2">Affinity Suite</p>
                <p className="font-semibold mt-2">Adobe Suite</p>
                <p className="font-semibold mt-2">Blender</p>
                <p className="font-semibold mt-2">Figma</p>
              </div>

              <div className="text-center">
                <h1 className="text-xl font-bold">Front End</h1>
                <hr />
                <p className="font-semibold mt-2">HTML</p>
                <p className="font-semibold mt-2">Java Script</p>
                <p className="font-semibold mt-2">CSS</p>
                <p className="font-semibold mt-2">React</p>
              </div>

              <div className="text-right">
                <h1 className="text-xl font-bold">Back End</h1>
                <hr />
                <p className="font-semibold mt-2">Node JS</p>
                <p className="font-semibold mt-2">Express JS</p>
                <p className="font-semibold mt-2">Mongo DB</p>
                <p className="font-semibold mt-2">Mongoose</p>
              </div>
            </div>
          </div>
        </div>

        {/* Info */}
        <div>
          <h1
            className="text-4xl text-themedk text-center font-bold"
            data-aos="fade-up"
          >
            Who is Vino ?
          </h1>
          <div className="h-screen relative text-gray-800 " data-aos="zoom-in">
            <div className="h-full">
              <lottie-player
                src="https://assets6.lottiefiles.com/packages/lf20_dcatp5cr.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <h1 className="text-2xl font-bold ">
                Hello :D
                <hr />
                <pre className="text-xl md:text-sm my-5 font-mont">
                  {JSON.stringify(
                    {
                      name: "Vino",
                      country: "India",
                      interests: "Designing",
                      hobby: "Illustrations",
                    },
                    null,
                    2
                  )}
                </pre>
              </h1>
            </div>
          </div>
        </div>

        {/* contact */}

        <div className="my-20" data-aos="fade-up">
          <div className="text-center h-52 bg-theme">
            <h1 className="text-themedk font-bold md:text-xl text-4xl py-10">
              <b>Need help with UI/UX designs?</b> Get in touch with me :D
            </h1>
          </div>

          <div
            className="md:mx-5 mx-32 shadow-2xl bg-gray-50 -mt-20 rounded-lg hover:bg-compdk hover:text-themelt"
            data-aos="zoom-out-down"
          >
            <div className="h-96">
              <lottie-player
                src="https://assets8.lottiefiles.com/packages/lf20_kdx6cani.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
          </div>
        </div>

        <div data-aos="fade-up">
          <div className="w-screen flex justify-center">
            <div className="md:w-full w-1/2 p-10 shadow-2xl bg-gray-50">
              <form ref={formRef} onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Name"
                  name="user_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full border-2 border-gray-400 rounded p-1 shadow-lg mt-5"
                />

                <input
                  type="text"
                  placeholder="Subject"
                  name="user_subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="w-full border-2 border-gray-400 rounded p-1 shadow-lg mt-5"
                />

                <input
                  type="email"
                  placeholder="Email"
                  name="user_email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border-2 border-gray-400 rounded p-1 shadow-lg mt-5"
                />

                <textarea
                  type="text"
                  placeholder="Message"
                  name="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full border-2 border-gray-400 rounded p-1 shadow-lg mt-5"
                />

                <button className="shadow-md bg-themedk rounded text-white px-5 py-1 mt-3">
                  SUBMIT
                </button>
              </form>
              <button
                onClick={clearMessages}
                className="shadow-md bg-themelt rounded text-compdk px-5 py-1 mt-3"
              >
                CLEAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
